/* storybook-check-ignore */
import { ListItem } from '@opendoor/bricks/core';
import {
  HeaderNavigationItem,
  HeaderNavigationItemProps,
} from 'components/exclusives/layout/Headerv2/HeaderNavigation/HeaderNavigationItem';
import type { ReactNode } from 'react';

export type HeaderMenuItemProps = Pick<
  HeaderNavigationItemProps,
  'analyticsName' | 'children' | 'href' | 'isExternalLink'
> & {
  icon?: ReactNode;
  isMobileOnly?: boolean;
  label: string;
};

export const HeaderMenuItem = ({
  analyticsName,
  href,
  isExternalLink,
  isMobileOnly,
  icon,
  label,
}: HeaderMenuItemProps) => {
  return (
    <ListItem display={isMobileOnly ? ['block', null, null, 'none'] : 'block'}>
      <HeaderNavigationItem
        analyticsName={analyticsName}
        aria-label={`Go to ${label}`}
        href={href}
        isExternalLink={isExternalLink}
      >
        {icon}
        {label}
      </HeaderNavigationItem>
    </ListItem>
  );
};
